function convertTo12HourFormat(input) {
  if (input == null || input === "") return "";

  let date;
  if (input && typeof input.toDate === "function") {
    date = input.toDate();
  } else {
    date = input instanceof Date ? input : new Date(input);
  }

  if (Number.isNaN(date.getTime())) return "";

  // API stores wall time as UTC (e.g. 2026-04-14T21:30:00+00:00). Use UTC components
  // so display matches the string; local getHours() shifts zones (e.g. 9:30 PM UTC → 3:00 AM IST).
  let hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12;

  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${hours}:${formattedMinutes} ${ampm}`;
}

export { convertTo12HourFormat };
